if (!customElements.get('featured-collection-custom')) {
  class featuredCollectionCustom extends HTMLElement {
    constructor() {
      super();
      this.flickityEle = this.querySelector('.main-carousel');

      this.initFlickity();
    }

    initFlickity() {
      const elementSelf = this;

      new Flickity(this.flickityEle, {
        prevNextButtons: true,
        pageDots: false,
        wrapAround: true,
        contain: true,
        cellAlign: 'center',
        dragThreshold: 8,
        groupCells: true,
        arrowShape: {
          x0: 20,
          x1: 60,
          y1: 40,
          x2: 60,
          y2: 35,
          x3: 25,
        },
        lazyLoad: 3,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              groupCells: 3,
            },
          },
        ],
        on: {
          ready: function () {
            const carousel_intro = elementSelf.querySelector('.js-carousel-intro');
            carousel_intro.classList.add('tw-max-h-none');
            carousel_intro.classList.remove('tw-max-h-72');
            carousel_intro.classList.remove('md:tw-max-h-96');
          },
        },
      });
    }
  }

  customElements.define('featured-collection-custom', featuredCollectionCustom);
}
